// Mobile menu: hamburger toggle + accordion groups with drill-down levels
// (root -> subcategory -> product list, with a "voltar" item to step back).
import { onClickOutside, onEscape } from './dismiss.js';

function getGroupTrigger(group) {
  return group.querySelector('[data-menu-group-toggle]');
}

function getGroupPanel(group) {
  return group.querySelector('[data-menu-group-panel]');
}

function showView(group, name) {
  group.querySelectorAll('[data-menu-view]').forEach((view) => {
    view.classList.toggle('is-active', view.dataset.menuView === name);
  });
}

function closeGroup(group) {
  const trigger = getGroupTrigger(group);
  const panel = getGroupPanel(group);
  if (trigger) trigger.setAttribute('aria-expanded', 'false');
  if (panel) panel.classList.remove('is-open');
  showView(group, 'root');
}

function openGroup(group) {
  const trigger = getGroupTrigger(group);
  const panel = getGroupPanel(group);
  if (trigger) trigger.setAttribute('aria-expanded', 'true');
  if (panel) panel.classList.add('is-open');
}

export function initMenu() {
  const root = document.querySelector('[data-menu]');
  const toggle = root?.querySelector('[data-menu-toggle]');
  const panel = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
  if (!panel) return;

  const groups = Array.from(panel.querySelectorAll('[data-menu-group]'));

  const closePanel = () => {
    toggle.setAttribute('aria-expanded', 'false');
    panel.classList.remove('is-open');
    groups.forEach(closeGroup);
  };

  toggle.addEventListener('click', () => {
    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      closePanel();
      return;
    }
    toggle.setAttribute('aria-expanded', 'true');
    panel.classList.add('is-open');
  });

  groups.forEach((group) => {
    const trigger = getGroupTrigger(group);
    if (!trigger) return;

    trigger.addEventListener('click', () => {
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';

      groups.filter((other) => other !== group).forEach(closeGroup);

      if (isOpen) {
        closeGroup(group);
      } else {
        openGroup(group);
      }
    });

    group.querySelectorAll('[data-menu-goto]').forEach((button) => {
      button.addEventListener('click', () => {
        showView(group, button.dataset.menuGoto);
      });
    });

    group.querySelectorAll('[data-menu-back]').forEach((button) => {
      button.addEventListener('click', () => {
        showView(group, 'root');
      });
    });
  });

  panel.querySelectorAll('[data-menu-leaf]').forEach((link) => {
    link.addEventListener('click', closePanel);
  });

  onClickOutside(root, closePanel);
  onEscape(closePanel);
}
